import { Button } from '@repo/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { PenLineIcon } from 'lucide-react'
import { useState } from 'react'

import { ReportTemplateForm } from '@/components/beneficiary/report/ReportTemplateCreator'
import { ItemCreatedDate, ItemUpdatedDate } from '@/components/CollapsibleCard'
import { ReportTemplate } from '@/store/report-templates/types'

export function ReportTemplateEditor({
  isDisabled,
  reportTemplate,
}: {
  isDisabled: boolean
  reportTemplate: ReportTemplate
}) {
  const { tc } = useT()
  const [open, setOpen] = useState(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <TooltipWrapper content={tc('edit', { cfl: true })}>
        <DialogTrigger disabled={isDisabled} asChild>
          <Button variant="outline" size="icon" disabled={isDisabled}>
            <PenLineIcon className="size-4" />
          </Button>
        </DialogTrigger>
      </TooltipWrapper>

      <DialogContent className="max-h-[90vh] max-w-6xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {tc('edit', { cfl: true })} {reportTemplate.name}
          </DialogTitle>
          <div className="text-primary-500 flex flex-row items-center gap-2">
            <ItemCreatedDate createdAt={reportTemplate.createdAt} /> •{' '}
            <ItemUpdatedDate updatedAt={reportTemplate.updatedAt} />
          </div>
        </DialogHeader>

        <ReportTemplateForm
          editableReportTemplate={reportTemplate}
          onSubmitted={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
